import React from 'react';

const LoadingSkeleton = ({ count = 1, className = '' }) => {
  return (
    <div className={className}>
      {[...Array(count)].map((_, i) => (
        <div key={i} className="bg-[#0a0a0a] rounded-2xl sm:rounded-3xl p-6 border border-white/[0.05] mb-4 last:mb-0">
          <div className="animate-pulse space-y-4">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-white/[0.04] rounded-xl shrink-0"></div>
              <div className="flex-1 space-y-2">
                <div className="h-4 bg-white/[0.04] rounded-lg w-1/3"></div>
                <div className="h-3 bg-white/[0.03] rounded-lg w-1/2"></div>
              </div>
            </div>
            <div className="space-y-3">
              <div className="h-3 bg-white/[0.04] rounded-lg"></div>
              <div className="h-3 bg-white/[0.03] rounded-lg w-5/6"></div>
              <div className="h-3 bg-white/[0.03] rounded-lg w-4/6"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LoadingSkeleton;